"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizes = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.sizes = {
    xs: 12,
    sm: 16,
    md: 20,
    lg: 26,
    xl: 36,
};
exports.default = react_jss_1.createUseStyles({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
    },
    checkboxWrapper: function (_a) {
        var size = _a.size;
        return ({
            position: 'relative',
            width: theme_1.getSizeValue({ size: size, sizes: exports.sizes }),
            height: theme_1.getSizeValue({ size: size, sizes: exports.sizes }),
        });
    },
    label: function (_a) {
        var theme = _a.theme, size = _a.size;
        return (__assign(__assign({}, theme_1.getFontStyles(theme)), { WebkitTapHighlightColor: 'transparent', paddingLeft: theme.spacing.sm, fontSize: theme_1.getSizeValue({ size: size, sizes: theme.fontSizes }), lineHeight: theme_1.getSizeValue({ size: size, sizes: exports.sizes }) + "px", color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black }));
    },
    checkbox: function (_a) {
        var size = _a.size, theme = _a.theme, color = _a.color;
        return (__assign(__assign({}, theme_1.getFocusStyles(theme)), { appearance: 'none', backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0], border: "1px solid " + (theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[4]), width: theme_1.getSizeValue({ size: size, sizes: exports.sizes }), height: theme_1.getSizeValue({ size: size, sizes: exports.sizes }), borderRadius: theme.radius.sm, padding: 0, outline: 0, display: 'block', margin: 0, '&:checked': {
                backgroundColor: theme_1.getThemeColor({
                    theme: theme,
                    color: color,
                    shade: theme.colorScheme === 'dark' ? 4 : 6,
                }),
                borderColor: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 6 }),
                color: theme.white,
                '& + $icon': {
                    color: theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.white,
                    display: 'block',
                },
            }, '&:disabled': {
                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2],
                borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[3],
                cursor: 'not-allowed',
                '& + $icon': {
                    color: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[5],
                },
            } }));
    },
    icon: {
        display: 'none',
        pointerEvents: 'none',
        width: '80%',
        height: '80%',
        position: 'absolute',
        zIndex: 1,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        margin: 'auto',
    },
}, { link: true });
